import { render, staticRenderFns } from "./SavedResetList.vue?vue&type=template&id=04c99d08&scoped=true&"
import script from "./SavedResetList.vue?vue&type=script&lang=js&"
export * from "./SavedResetList.vue?vue&type=script&lang=js&"
import style0 from "./SavedResetList.vue?vue&type=style&index=0&id=04c99d08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c99d08",
  null
  
)

export default component.exports